/**
 * Jambuveda Policy page — accordion, same pattern as the FAQ section.
 */
(function () {
  const items = document.querySelectorAll('.jv-pol__item');
  items.forEach((item) => {
    const btn = item.querySelector('.jv-pol__q');
    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
})();
